import {Component, OnInit} from '@angular/core';
import {NavigatorService} from '../services/common/navigator.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-arm',
    templateUrl: './arm.component.html',
    styleUrls: ['./arm.component.scss']
})
export class ArmComponent implements OnInit {

    constructor(public navigator: NavigatorService) {
    }

    ngOnInit(): void {
    }


}
